"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const GenericError_1 = require("../errors/GenericError");
/**
 * Manage the errors returned by the SDK methods
 *
 * @param axiosError - the axios error object with the API response
 * @param CustomError - the Error instance we want to raise, example: UserError
 * @param {ErrorManagerOptions} options - the prefix to the error message we want to show
 *
 * @throws GenericError - throws the error gave in the parameters
 */
const errorManager = (axiosError, CustomError, opts) => {
    var _a, _b, _c;
    const { prefix, errors = [] } = opts || {};
    if (axiosError && 'errorCode' in axiosError) {
        throw axiosError;
    }
    if (errors === null || errors === void 0 ? void 0 : errors.length) {
        errors.forEach((error) => {
            var _a, _b, _c;
            if (axiosError === null) {
                throw new CustomError('', `${prefix}${error.message || ''}`, error.statusCode);
            }
            if ('errorCode' in axiosError) {
                return;
            }
            if (error.statusCode === ((_a = axiosError === null || axiosError === void 0 ? void 0 : axiosError.response) === null || _a === void 0 ? void 0 : _a.status)) {
                // Set the default API error message
                // If a custom message error has been defined, show it, or show the default API error message
                const errorMessage = error.message || ((_b = axiosError.response.data) === null || _b === void 0 ? void 0 : _b.message);
                // checks if a prefix is defined
                const formattedPrefix = prefix ? `${prefix}: ` : '';
                // errorCode has the API error type, example: IllegalArgument, and the prefix concerns
                // the actual method where the errorManager is called
                throw new CustomError((_c = axiosError.response.data) === null || _c === void 0 ? void 0 : _c.type, `${formattedPrefix}${errorMessage}`, error.statusCode, axiosError);
            }
            return;
        });
    }
    else {
        if ('errorCode' in axiosError) {
            return;
        }
        throw new GenericError_1.GenericError((_a = axiosError.response.data) === null || _a === void 0 ? void 0 : _a.type, ((_b = axiosError.response.data) === null || _b === void 0 ? void 0 : _b.message) || ((_c = axiosError.response.data) === null || _c === void 0 ? void 0 : _c.errorMessage), axiosError.response.status, axiosError);
    }
};
exports.default = errorManager;
